'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _routeParser = require('./route-parser.js');

var _routeParser2 = _interopRequireDefault(_routeParser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (items) {
    var matchers = (items || []).map(function (item) {
        return { item: item, isMatch: (0, _routeParser2.default)(item.pattern) };
    });

    return function (pathname) {
        for (var i = 0; i < matchers.length; i++) {
            var params = matchers[i].isMatch(pathname);

            if (params) {
                return {
                    item: matchers[i].item,
                    params: params
                };
            }
        }
    };
};
//# sourceMappingURL=route-matcher.js.map